import React from "react";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

export function permissionGroupsColumns({ onEdit, onDelete }) {
  return [
    {
      header: "name",
      accessor: "name",
      width: "25%",
      render: (row) => (
        <MDTypography variant="caption" color="text" fontWeight="regular">
          {row.name}
        </MDTypography>
      ),
    },
    {
      header: "Description",
      accessor: "description",
      width: "30%",
      render: (row) => (
        <MDTypography variant="caption" color="text" fontWeight="regular">
          {row.description}
        </MDTypography>
      ),
    },
    {
      header: "Permissions",
      accessor: "num_permission",
      align: "right",
      render: (row) => (
        <MDBadge badgeContent={(row.permissions || []).length} size="sm" container />
      ),
    },
    {
      header: "action",
      accessor: "action",
      align: "center",
      render: (row) => (
        <div>
          <IconButton size="small" onClick={() => onEdit(row)}>
            <Icon fontSize="small">edit</Icon>
          </IconButton>
          <IconButton size="small" color="error" onClick={() => onDelete(row)}>
            <Icon fontSize="small">delete</Icon>
          </IconButton>
        </div>
      ),
    },
  ];
}
